<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-container-single element-non-bodymatter element-type-none element-with-heading" id="uncategorized">
<div class="heading heading-with-title heading-without-image" id="uncategorized-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Book Description</h1>
</div>
</div>
</div>
</div>
<div class="text" id="uncategorized-text">
<p class="first first-in-chapter first-full-width">Set sail on the high seas with this collection of twenty-one unforgettable short stories featuring dashing rogues, daring rebels, and wily pirates searching for treasures of all kinds, including a forgotten journal, a heavenly sword, a young girl’s lucky sock, and even the Fountain of Youth.</p>
<p class="subsq">Some pirates are familiar—complete with parrots, peg legs, and eye patches—but most are unique: a twelve-year-old computer hacker, a heroic rabbit on an unusual quest, a clump of cancer cells, and an alien setting sail among the stars.</p>
<p class="subsq"><i>X Marks the Spot: An Anthology of Treasure and Theft</i> is about those men and women who live on the fringes of society, who are beholden to no man, no law, and who always have one eye on the horizon.</p>
<p class="subsq">So grab your map and set your headings. There are adventures to be had, mateys, and treasures to be found.</p>
<p class="subsq">This anthology is the fifth volume produced by the alumni of the Superstars Writing Seminars, and all royalties benefit the Don Hodge Memorial Scholarship Fund.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bookdescription.vue?2066a4c6